/* eslint-disable @typescript-eslint/naming-convention -- API defined property names */
import { TWResponse } from './response.models';

export class SensorV2 {
  sensorBk: string;
  levelBk: HierarchyLevel | HierarchyLevelV2;
  sensorType: string;
  sensorSubtype: string;
  aggregationType: string;
  aggregationLevel: string;
  computationType: ComputationType;
  valueType: string;
  unit: string;
  name: string;
  standardSensorBk: string;
  key: string;
}

export class Sensor {
  id: string;
  name?: string;
  container_id?: string;
  system_id?: string;
  customer_bk?: string;
  system_bk?: string;
  sensor_bk?: string;
  computation_type?: string;
  value_type?: string;
  component_bk?: string;
  standard_sensor_bk?: string;
  generated_name?: string;
  level_bk?: HierarchyLevel;

  type?: string;
  type_id?: number;
  unit: string;
  is_virtual?: boolean;
  is_internal?: boolean;
  id_from_client?: string;
  address_from_client?: string;
  sampling_rate?: number;
  config_data: unknown;

  static getSensorLabel(sensor: Sensor, withUnit = false) {
    let label = sensor.name ? sensor.name : sensor.type;
    if (withUnit && sensor.unit.trim()) {
      label += ` [${sensor.unit}]`;
    }
    return label;
  }
}

export enum HierarchyLevel {
  Cell = 'cell',
  String = 'string',
  Cluster = 'cluster',
  Inverter = 'inverter',
  InverterModule = 'inverter_module',
  Module = 'module',
  System = 'system',
}

export enum HierarchyLevelV2 {
  Cell = 'cell',
  StringModule = 'string_module',
  StringModulePCS = 'string_module_pcs',
  String = 'string',
  StringPCS = 'string_pcs',
  StringGroup = 'string_group',
  DCCombiner = 'dc_combiner',
  PCSModule = 'pcs_module',
  PCS = 'pcs',
  ACCombiner = 'ac_combiner',
  Enclosure = 'enclosure',
  Transformer = 'transformer',
  System = 'system',
}

export enum ComputationType {
  Computation = 'computation',
  Aggregation = 'aggregation',
  Measurement = 'measurement',
}


export class SensorDataV2 extends TWResponse {
  total_pages: string;
  page_size: number;
  page: number;
  prev?: string;
  next?: string;
  items: Sensor[];
}

export class SensorListResponseV2 extends TWResponse {
  data: SensorDataV2;
}
